export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Industries", path: "/industries" },
  { name: "Insights", path: "/insights" },
  { name: "Contact", path: "/contact" },
];

export const CONTACT_INFO = {
  phone: "+91 8895507451",
  email: "admin@yantrakshprojects.com",
  website: "www.yantrakshprojects.com",
  address: "Bhubaneswar, Odisha, 751024",
  whatsapp: "918895507451",
};

export const SERVICES = [
  {
    id: "mechanical-structural",
    title: "Mechanical & Structural",
    description:
      "Heavy steel structure fabrication, structural erection, equipment installation, refurbishment & overhauling, and industrial roofing & sheeting systems.",
    icon: "Factory",
    image:
      "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Heavy Steel Fabrication",
      "Structural Erection",
      "Equipment Installation",
      "Refurbishment & Overhauling",
      "Industrial Roofing & Sheeting",
    ],
  },
  {
    id: "civil-electrical",
    title: "Civil & Electrical Infrastructure",
    description:
      "Industrial foundations, site development, electrical panel installation, cabling and power distribution, and complete utility infrastructure solutions.",
    icon: "Building2",
    image:
      "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Industrial Foundations",
      "Site Development",
      "Electrical Panels",
      "Cabling & Power Distribution",
      "Utility Infrastructure",
    ],
  },
  {
    id: "predictive-om",
    title: "Predictive Plant O&M",
    description:
      "Annual Maintenance Contracts, daily plant operation support, vibration analysis, thermography, oil analysis (tribology), and technical manpower services.",
    icon: "Activity",
    image:
      "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Annual Maintenance Contracts",
      "Daily Plant Operation",
      "Vibration Analysis",
      "Thermography",
      "Oil Analysis & Tribology",
      "Technical Manpower",
    ],
  },
  {
    id: "regulatory",
    title: "Environmental & Regulatory",
    description:
      "Environmental Clearance (EC), Forest Clearance (FC), DGMS / IBM / SPCB liaisoning, compliance management, and technical audits & budgeting support.",
    icon: "FileCheck",
    image:
      "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1200&q=80",
    features: [
      "Environmental Clearance (EC)",
      "Forest Clearance (FC)",
      "DGMS / IBM / SPCB Liaisoning",
      "Compliance Management",
      "Technical Audits & Budgeting",
    ],
  },
];

export const SERVICE_OPTIONS = [
  "Mechanical & Structural Solutions",
  "Civil & Electrical Infrastructure",
  "Predictive Plant O&M",
  "Environmental & Regulatory Consultancy",
  "Turnkey Project Execution",
  "Brownfield Modernization",
  "Other",
];

export const KEY_HIGHLIGHTS = [
  { icon: "Wrench", title: "Turnkey Project Execution" },
  { icon: "Activity", title: "Predictive Plant O&M" },
  { icon: "FileCheck", title: "Environmental & Regulatory Consultancy" },
  { icon: "Cpu", title: "AI-Powered Industrial Optimization" },
  { icon: "ShieldCheck", title: "Zero-Tolerance Safety Culture" },
];

export const LIFECYCLE_STEPS = [
  { n: "01", title: "Regulatory Approvals", desc: "EC, FC & all statutory clearances secured upfront." },
  { n: "02", title: "Greenfield Construction", desc: "Site development, civil foundations & structural works." },
  { n: "03", title: "Equipment Installation", desc: "Precision erection and mechanical installation." },
  { n: "04", title: "Plant Commissioning", desc: "Testing, integration and operational handover." },
  { n: "05", title: "Operations & Maintenance", desc: "Daily ops support and predictive maintenance." },
  { n: "06", title: "Brownfield Expansion", desc: "Modernization & retrofits with minimal disruption." },
  { n: "07", title: "Continuous Optimization", desc: "Data-driven efficiency and reliability gains." },
];

export const AI_FEATURES = [
  { title: "Predictive Analytics", icon: "TrendingUp" },
  { title: "Equipment Health Monitoring", icon: "Activity" },
  { title: "Real-Time Plant Data Analysis", icon: "Gauge" },
  { title: "Resource Optimization", icon: "Cpu" },
  { title: "Automated Maintenance Scheduling", icon: "CalendarClock" },
  { title: "Data-Driven Decision Making", icon: "BarChart3" },
];

export const SAFETY_POINTS = [
  { title: "Zero Accident Policy", icon: "ShieldCheck" },
  { title: "Zero Environmental Incidents", icon: "Leaf" },
  { title: "Global Safety Standards", icon: "Globe" },
  { title: "Continuous Workforce Training", icon: "GraduationCap" },
  { title: "Compliance-Driven Operations", icon: "FileCheck" },
];

export const INDUSTRY_CHALLENGES = [
  { challenge: "Fragmented project execution", solution: "Single-point project ownership across all disciplines." },
  { challenge: "Equipment downtime", solution: "Predictive maintenance that prevents failures before they occur." },
  { challenge: "Regulatory delays", solution: "Complete, end-to-end regulatory and clearance support." },
  { challenge: "Brownfield expansion risks", solution: "Seamless plant modernization with minimal disruption." },
];

export const INDUSTRIES = [
  { name: "Mining & Minerals", icon: "Pickaxe" },
  { name: "Steel & Metals", icon: "Factory" },
  { name: "Metals Processing", icon: "Flame" },
  { name: "Manufacturing", icon: "Cog" },
  { name: "Industrial Infrastructure", icon: "Building2" },
];

export const CLIENTS = [
  "Mining Corporation",
  "Integrated Steel Major",
  "Metals Processing Ltd.",
  "Heavy Manufacturing Co.",
  "Power Generation Group",
  "Industrial Infra Developers",
];

export const STATS = [
  { label: "Projects Delivered", value: "50+" },
  { label: "Years of Experience", value: "15+" },
  { label: "Expert Engineers", value: "200+" },
  { label: "Safety Record", value: "100%" },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Plant Head, Steel Major",
    content:
      "Yantraksh transformed our O&M strategy. Their predictive maintenance approach saved us significant downtime.",
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Director, Global Mining Corp",
    content:
      "Their regulatory consultancy team navigated complex approvals seamlessly for our greenfield project.",
  },
];

export const HERO_IMAGES = [
  "https://customer-assets.emergentagent.com/job_yantraksh-projects/artifacts/5z34rtd9_Gemini_Generated_Image_tradqutradqutrad.png",
  "https://customer-assets.emergentagent.com/job_yantraksh-projects/artifacts/xvbjnbfi_Gemini_Generated_Image_dnmusndnmusndnmu.png",
  "https://customer-assets.emergentagent.com/job_yantraksh-projects/artifacts/14rqzt5h_Image1.png",
];

export const CSR_IMAGES = [
  "https://customer-assets.emergentagent.com/job_yantraksh-projects/artifacts/14rqzt5h_Image1.png",
  "https://customer-assets.emergentagent.com/job_yantraksh-projects/artifacts/5z34rtd9_Gemini_Generated_Image_tradqutradqutrad.png",
  "https://customer-assets.emergentagent.com/job_yantraksh-projects/artifacts/xvbjnbfi_Gemini_Generated_Image_dnmusndnmusndnmu.png",
];

export const CSR_INITIATIVES = [
  {
    title: "Community Development",
    description:
      "Investing in local infrastructure, education, and healthcare programs in the communities surrounding our project sites.",
    icon: "HeartHandshake",
  },
  {
    title: "Environmental Stewardship",
    description:
      "Land reclamation, afforestation drives, and sustainable practices that minimize ecological impact.",
    icon: "Leaf",
  },
  {
    title: "Skill & Livelihood",
    description:
      "Vocational training and skill-development initiatives that create employment opportunities for local youth.",
    icon: "GraduationCap",
  },
];
